import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

import { Text, Box } from '../../Base';

import DownloadableItem from './DownloadableItem';

const DownloadableItemWrapper = ({ materials, onDownloadClick, noMaterialMessage }) => {
  const { colors } = useTheme();
  return Array.isArray(materials) && materials.length ? (
    <Fragment>
      {materials.map((material) => (
        <Box key={material.id}>
          <DownloadableItem {...material} onDownloadClick={onDownloadClick} />
        </Box>
      ))}
    </Fragment>
  ) : (
    <Box style={{ borderBottom: `1px solid ${colors.greyscale.grey5}` }}>
      <Text
        textStyle={'subtitle1'}
        fontWeight={'normal'}
        textAlign="center"
        color={colors.greyscale.grey3}
        my={4}
      >
        {noMaterialMessage}
      </Text>
    </Box>
  );
};

DownloadableItemWrapper.propTypes = {
  materials: PropTypes.arrayOf(PropTypes.object),
  onDownloadClick: PropTypes.func,
  noMaterialMessage: PropTypes.string,
};

DownloadableItemWrapper.defaultProps = {
  material: [],
  onDownloadClick: () => {},
  noMaterialMessage: 'บทเรียนนี้ไม่มีเอกสารเพิ่มเติม',
};

export default DownloadableItemWrapper;
